import { Sentry } from '@/lib/sentry'

const seen = new Set<string>()

export function captureLegacyIdRoute(resource: string, routeId: string) {
  const key = `${resource}:${routeId}`
  if (seen.has(key)) return
  seen.add(key)

  Sentry.captureMessage('Legacy private-id route used', {
    level: 'warning',
    tags: {
      feature: 'public-id',
      resource,
    },
    extra: {
      routeId,
    },
  })
}
